module.exports = __webpack_public_path__ + "../resources/images/like-bf082305eb9e6dccd12c9cb7deba7bf7.svg";